<app-dialog
  width="auto"
  [options]="options"
  [contentTemplateRef]="bodyTemplate"
  (accept)="onAccept()"
  (reject)="onReject()"
></app-dialog>

<ng-template #bodyTemplate>
  <span>Вы уверены?</span>
</ng-template>
